<app-header class="headerContainer"></app-header>
<app-summary-table
  class="summaryContainer"
  (refId)="validationId($event)"
></app-summary-table>
<app-rule-details
  class="detailsContainer"
  [validationId]="refId"
></app-rule-details>
